export default __webpack_public_path__ + "static/ContactFormTextAndImage-babd060d696231644a21829780e40701.jpg";